import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.loadInstabookScript()
  }

  loadInstabookScript() {
    if (document.querySelector('script[src*="instabook_mod.js"]')) {
      return
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = 'http://ib.guestonline.fr/instabook/js/instabook_mod.js'

    const firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode.insertBefore(script, firstScript)
  }
}
